import { localStorageManager } from '@mopla/utils';

export const emailSendTimeLSManager =
	localStorageManager<number>('emailSendTime');
